/**
 * API membri per creazione schede manuale giochi (sempre bozza).
 */

async function parseJsonResponse(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(
      data.message || data.error || `Errore HTTP ${res.status}`
    );
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function createManualeGiocoMine(data) {
  const res = await fetch('/api/manuale-giochi/mine', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ data }),
  });
  return parseJsonResponse(res);
}

export async function uploadManualeGiocoMineFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch('/api/manuale-giochi/mine/upload', {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  return parseJsonResponse(res);
}
